import React from 'react';
import { buildClassName } from '../../../utils';
import type { LinkNavigationButton } from '../../../types';
import type { NavigationActionHandler, NavigationStyleOverrides } from '../../../types/base';
import { NavigationButtonBase } from './NavigationButtonBase';
import styles from '../DesktopNavigation.module.scss';

interface NavigationButtonLinkProps {
  item: LinkNavigationButton;
  styleOverrides?: NavigationStyleOverrides;
  onAction?: NavigationActionHandler;
}

export const NavigationButtonLink = ({ 
  item, 
  styleOverrides = {}, 
  onAction,
}: NavigationButtonLinkProps) => {
  const handleClick = () => {
    // Handle custom action handlers first (e.g., modal triggers, API calls)
    if (item.metadata?.handler && onAction) {
      onAction(item.metadata.handler, item.metadata.params);
      return;
    }
    
    // Handle navigation to URLs
    if (item.href) {
      if (item.external) {
        window.open(item.href, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = item.href;
      }
    }
  };

  return (
    <div className={buildClassName(styles.buttonContainer, styleOverrides.navButton)}>
      <NavigationButtonBase
        className={styleOverrides.navButton}
        onClick={handleClick}
        aria-label={item.label}
      >
        {item.leftSection}
        {item.label}
        {item.rightSection}
      </NavigationButtonBase>
    </div>
  );
}; 